<template>
  <v-row class="pa-0">
    <v-col
      cols="12"
      md="6"
    >
      <v-autocomplete
        ref="autocomplete"
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        clearable
        :height="(multiple ? (model && model.length > 1 ? 'auto' : 32) : '32')"
        :hide-details="(rules ? false : true)"
        return-object
        item-text="name"
        :rules="(rules ? rules : [])"
        :required="(rules ? true : false)"
        item-value="id"
        :label="$t('quickPersonAccess')"
        :dense="(multiple ? true : true)"
        :chips="(multiple ? multiple : null)"
        :multiple="(multiple ? multiple : null)"
        :filled="(filled ? filled : false)"
        :flat="(flat ? flat : false)"
        :solo="(solo ? solo : false)"
        :disabled="disabled"
        :outlined="(outlined ? outlined : true)"
      >
        <template v-slot:append>
          <v-slide-x-reverse-transition
            mode="out-in"
          >
            <v-icon
              :key="`icon-${appendIcon}`"
              :color="notFind ? 'success' : 'secondary'"
              @click="appendIcon = !appendIcon"
              v-text="notFind ? 'mdi-check-outline' : 'mdi-chevron-down'"
            />
          </v-slide-x-reverse-transition>
        </template>
        <template v-slot:no-data>
          <!--        <v-list-item>-->
          <!--          <v-list-item-content>-->
          <!--            <v-list-item-title v-text="search" />-->
          <!--            <v-list-item-subtitle>{{ $t('no-data') }}</v-list-item-subtitle>-->
          <!--          </v-list-item-content>-->
          <!--          <v-list-item-action>-->
          <!--            <v-icon color="success">-->
          <!--              mdi-check-outline-->
          <!--            </v-icon>-->
          <!--          </v-list-item-action>-->
          <!--        </v-list-item>-->
        </template>
        <template
          v-if="!multiple"
          v-slot:selection="{item}"
        >
          <span v-text="item.name" />
        </template>
        <template
          v-if="multiple"
          v-slot:selection="{item}"
        >
          <v-chip
            close
            small
            dark
            :color="item.color"
            class="my-1"
            @click:close="remove(item)"
          >
            {{ item.name }}
          </v-chip>
        </template>
        <template
          v-slot:hint="{item}"
        >
          {{ item.name }}
        </template>
        <template
          v-slot:append
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="append"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                v-on="on"
                @click="setDefault"
              >
                <v-icon
                  medium
                >
                  mdi-account-check-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('set-to-default') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'person'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                v-on="on"
                @click.stop.prevent="accountDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-account-plus-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-account') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'product'|| newBtn && type === 'productService'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                v-on="on"
                @click.stop.prevent="productDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('product') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="newBtn && type === 'product' || newBtn && type === 'productService'"
                color="primary"
                v-bind="attrs"
                icon
                small
                style="margin: 0px !important;margin-top: -3px !important;"
                v-on="on"
                @click.stop.prevent="barcodeDialog = true"
              >
                <v-icon
                  medium
                >
                  mdi-barcode-scan
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('product') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:append-item>
          <div
            v-if="items.length !== 0 && last_page > 1"
            v-observe-visibility="{
              callback: visibilityChanged
            }"
            class="text-center"
          >
            <v-progress-circular
              :size="20"
              :width="2"
              color="primary"
              indeterminate
            />
          </div>
        </template>
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.name" />
            <!--        <v-list-item-subtitle v-text="item.symbol" />-->
          </v-list-item-content>
          <v-list-item-action>
            <v-icon v-if="type== 'person'">
              mdi-account
            </v-icon>
            <v-chip
              v-if="item.label"
              class="mx-0"
              :color="(item.color ? item.color : 'primary')"
              label
              x-small
              outlined
            >
              {{ $t(item.label) }}
            </v-chip>
          </v-list-item-action>
        </template>
      </v-autocomplete>
    </v-col>
    <v-col
      cols="12"
      md="6"
      class="pb-0"
    >
      <buttons
        :account="model"
        @refresh="getInfo"
      />
    </v-col>
    <v-col
      v-if="model"
      cols="12"
      class="py-0"
      md="4"
    >
      <v-list dense>
        <v-list-item-group
          color="primary"
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('remain')}} : {{ (model.remain ? $numberFormat(model.remain.remain) + ' ' + $store.state.currency.name : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('category')}} : {{ (model.category ? model.category.name : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-cellphone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ (model.mobile ? model.mobile : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-map-marker-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ (model.address ? model.address : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
    <v-col
      v-if="model"
      cols="12"
      class="py-0"
      md="4"
    >
      <v-list dense>
        <v-list-item-group
          color="primary"
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-account-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('attractionMethod')}} : {{ (model.attraction_method ? model.attraction_method.name : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-shopping-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('lastBuyDate')}} : {{ (model.last_invoice ? model.last_invoice.date : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-registered-trademark</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ (model.user ? model.user.name : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-calendar-range</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ (model.time ? model.time : '-') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
    <v-col
      v-if="model"
      cols="12"
      class="py-0"
      md="4"
    >
      <v-list dense>
        <v-list-item-group
          color="primary"
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-tag-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <div>
                <v-chip
                  v-for="(tag, index) in model.tags"
                  :key="index"
                  :color="tag.color"
                  label
                  small
                  style="margin-left: 1px;margin-right:1px"
                  class="px-1 mb-1"
                >
              <span class="px-1 white--text">
                {{ tag.text }}
              </span>
                </v-chip>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="accountDialog"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="accountDialog = false"
          >
            <v-icon
              class="close-hover"
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('new-account') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <customer
              v-model="newAccount"
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="productDialog"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="productDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <product
              v-model="newProduct"
              form-type="product"
              @close="productDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="barcodeDialog"
      width="440px"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="barcodeDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="ma-2 mt-0"
          >
            <barcode
              @decode="(a, b, c) => onDecode(a, b, c)"
              @loaded="() => onLoaded()"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snackbar"
      :text="snakbarText"
      :active="snackbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
    />
  </v-row>
</template>

<script>
  import barcode from '../../components/general/barcode/barcode'
  import customer from '../../pages/account/customer'
  import Product from '../../pages/product/product'
  import General from '../../../../Mixins/general'
  import buttons from '../../components/general/patial/autocompleteButton'
  export default {
    name: 'Autocomplete',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      customer,
      Product,
      buttons,
      barcode,
    },
    mixins: [General],
    props: ['value', 'append', 'customerid', 'title', 'currencyProp', 'data', 'multiple', 'rules', 'init', 'setInit', 'outlined', 'filled', 'solo', 'flat', 'disabled', 'parent'],
    data: () => ({
      barcodeText: null,
      newProduct: null,
      barcodeDialog: false,
      productDialog: false,
      accountDialog: false,
      isLastPage: false,
      isLoading: false,
      appendIcon: 'chevron-down',
      snackbar: false,
      newAccount: null,
      last_page: 1,
      currency: null,
      snakbarText: null,
      snakbarColor: null,
      text: null,
      items: [],
      id: null,
      idd: null,
      // items: Array.from(Array(10).keys()),
      model: null,
      search: null,
      page: 1,
      timer: null,
      type: 'person',
      newBtn: true,
      notFind: null,
      tab: null,
      initList: null,
    }),
    watch: {
      value (val, old) {
        if (this.value) {
          this.setModel(this.value)
        } else {
          this.getItems({ query: null, page: 1 })
        }
      },
      newAccount () {
        if (this.newAccount) {
          this.accountDialog = false
          this.setModel(this.newAccount)
        }
      },
      newProduct () {
        if (this.newProduct) {
          this.productDialog = false
          this.setModel(this.newProduct)
        }
      },
      customerid (val, oldval) {
        this.setModel(val)
      },
      model (val) {
        if (val != null) {
          this.tab = 0
          if (this.notFind) {
            this.text = this.$t('alert-register-success')
            this.snackbar = true
          }
          this.$emit('input', this.model)
          this.$store.state.quickAccount = this.model
          // if (this.multiple) {
          //   this.$emit('input', this.model)
          // } else {
          //   this.$emit('input'
          //              , {
          //                showButton: true,
          //                name: val.name,
          //                id: val.id,
          //                type: val.type,
          //                code: val.code,
          //                group_id: val.group_id,
          //                remain: val.remain,
          //              })
          // }

          // if (this.id) {
          //   this.$emit('input', this.id)
          // }
        } else {
          this.tab = null
          this.$emit('input', null)
        }
      },
      search (val) {
        this.page = 1
        var index = this.items.findIndex(x => x.name === val)
        if (index === -1 && this.model) {
          val && val !== this.model.name && this.getItems({ query: val, page: 0 })
        } else {
          if (index === -1) {
            this.getItems({
              query: val,
              page: 0,
            })
          }
        }
      },
      currencyProp () {
        this.currency = this.currencyProp
        this.items = []
        this.page = 1
        this.initList = false
        this.getItems()
      },
    },
    mounted  () {
      if (this.$store.state.quickAccount) {
        this.setModel(this.$store.state.quickAccount)
      }
      this.newBtn = true
      this.type = 'person'
      this.currency = JSON.parse(localStorage.getItem('token')).init.currency
      if (this.currencyProp) {
        this.currency = this.currencyProp
      }
      if (this.value) {
        this.setModel(this.value)
      } else {
        this.getItems({ query: null, page: 1 })
      }
    },
    methods: {
      onDecode (a, b, c) {
        if (a) {
          this.search = a
          this.barcodeDialog = false
        }
      },
      onLoaded () {
        // var app = this
        // setTimeout(function () {
        //   app.onDecode('324234234', undefined, undefined)
        // }, 2000)
      },
      remove (item) {
        var index = this.model.findIndex(x => x.id === item.id && x.type === item.type)
        if (index >= 0) this.model.splice(index, 1)
      },
      setDefault () {
        var app = this
        if (app.model) {
          app.isLoading = true
          app.$axios.get(this.$endpoint + 'getdetail', {
            params: {
              select: 'setDefaultAccount',
              id: app.model,
            },
          })
            .then(res => {
              app.$emit('snackbarShow', { text: res.data.message, color: 'green' })
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }
      },
      setModel (item) {
        // this.items = [item]
        var app = this
        if (this.multiple) {
          app.items = [
            ...app.items,
            ...Array.from(item),
          ]
        } else {
          this.items.push(item)
        }
        this.model = item
        this.id = item
      },
      clear () {
        this.items = []
        this.model = null
      },
      visibilityChanged (e) {
        e && this.getItems()
      },
      getItems () {
        this.loading = true
        // simulates ajax request
        if (this.page === 1 && this.search == null && this.initList) {
          return false
        }
        this.initList = true
        var app = this
        app.isLoading = true
        var type = 'personWithDetails'
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail?select=' + type + '&search=' + app.search + '&page=' + app.page + '&currency=' + app.currency + '&data=' + app.data + '&parent_id=' + app.parent)
            .then(res => {
              res = res.data
              var setDef = false
              if (app.setInit && app.page === 1) {
                setDef = true
              }
              app.last_page = res.last_page
              if (res.last_page > app.page) {
                app.page++
              }
              if (res.last_page === res.current_page) {
                app.last_page = 1
              }
              // app.items = res.data
              app.items = [
                ...app.items,
                ...Array.from(res.data),
              ]
              if (setDef) {
                app.model = app.items[0]
              }
              if (res.data.length > 0) {
                app.notFind = null
              } else {
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 1000)
        this.loading = false
      },
      getInfo (id) {
        this.loading = true
        // simulates ajax request
        if (this.page === 1 && this.search == null && this.initList) {
          return false
        }
        this.initList = true
        var app = this
        app.isLoading = true
        var type = 'personWithDetails'
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail?select=' + type + '&search=' + app.search + '&page=' + app.page + '&currency=' + app.currency + '&data=' + app.data + '&parent_id=' + app.parent + '&id=' + id)
            .then(res => {
              res = res.data
              app.model = res.data[0]
              if (res.data.length > 0) {
                app.notFind = null
              } else {
              }
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 1000)
        this.loading = false
      },
    },
  }
</script>

<style scoped>
  .v-progress-circular {
    margin: 4px;
  }
</style>
